// extracted by mini-css-extract-plugin
export var leftAlign = "_2o-2";
export var popper = "_2o-0";
export var subtitle = "_2o-1";